import { render, staticRenderFns } from "./CreateHouseDialog.vue?vue&type=template&id=dacffb0c&scoped=true&lang=pug&"
import script from "./CreateHouseDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateHouseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacffb0c",
  null
  
)

export default component.exports